import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import toast from 'react-hot-toast';

export const useGSCOAuthCallback = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const gscSuccess = params.get('gsc_success');
    const gscError = params.get('gsc_error');

    if (gscSuccess === 'true') {
      toast.success('Google Search Console connected successfully!', {
        duration: 4000,
        position: 'top-right',
        style: {
          background: '#10B981',
          color: 'white',
        },
        iconTheme: {
          primary: 'white',
          secondary: '#10B981',
        },
      });
      
      // Clean up URL parameters
      const newParams = new URLSearchParams(location.search);
      newParams.delete('gsc_success');
      const newSearch = newParams.toString();
      const newUrl = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;
      history.replace(newUrl);
    }

    if (gscError) {
      let errorMessage = 'Failed to connect Google Search Console';
      
      // Map specific error codes to user-friendly messages
      switch (gscError) {
        case 'access_denied':
          errorMessage = 'Authorization was denied. Please try again and grant necessary permissions.';
          break;
        case 'missing_parameters':
          errorMessage = 'Authentication failed due to missing parameters. Please try again.';
          break;
        case 'invalid_state':
          errorMessage = 'Authentication failed due to invalid session. Please try again.';
          break;
        case 'state_expired':
          errorMessage = 'Authentication session expired. Please try again.';
          break;
        case 'organization_not_found':
          errorMessage = 'Organization not found. Please contact support.';
          break;
        case 'oauth_not_configured':
          errorMessage = 'OAuth is not properly configured. Please contact support.';
          break;
        case 'callback_failed':
          errorMessage = 'Failed to complete authentication. Please try again.';
          break;
        default:
          errorMessage = `Authentication failed: ${gscError}`;
      }

      toast.error(errorMessage, {
        duration: 4000,
        position: 'top-right',
        style: {
          background: '#EF4444',
          color: 'white',
        },
        iconTheme: {
          primary: 'white',
          secondary: '#EF4444',
        },
      });

      // Clean up URL parameters
      const newParams = new URLSearchParams(location.search);
      newParams.delete('gsc_error');
      const newSearch = newParams.toString();
      const newUrl = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;
      history.replace(newUrl);
    }
  }, [location.search, history]);
};

export default useGSCOAuthCallback;
